@if(loading == true){
    <div class="container-full">
        <div style="margin-top:20px;margin-left:60px;">
        <h2>Loading...</h2>
        </div>
    </div>
}
@else 
{
<div class="container-full">

                        <ng-template mat-tab-label>
                            <mat-icon class="example-tab-icon mr-2">people</mat-icon>
                            <span style="margin-left: 5px">
                                Edit Parker
                            </span>
                        </ng-template>

                <mat-card class="card-grid-border" style="margin-top:30px;margin-left:5px;margin-right:0px;width:calc(100% - 5px);height:800px;min-height: 600px;">
                        <mat-card-content>
                            @if(isProcessingSave){
                                <div style="margin-top:20px;margin-left:10px;margin-right:10px;">
                                    <app-processing-banner [WaitMessage]="processingMessage" style="margin-top:20px;margin-left:10px;margin-right:10px;"></app-processing-banner>
                                </div>
                            }
                        <form 
                        (ngSubmit)="onSubmitUpdateParkerProfile()" 
                        novalidate
                        [formGroup]="parkerEditForm" 
                        style="margin-top:5px;">
                        <span style="margin-left:0px;" class="lanai-page-title">Edit Information for Parker: {{headerLine}}</span>
                        <div class="row row-gap-0 mt-2">
                            <div class="col-3">
                                <mat-form-field appearance="fill" style="width:100%;color:gray">
                                    <mat-label>Company</mat-label>
                                    <mat-select formControlName="companyId" (selectionChange)="onCompanyNumberChange();">
                                      <mat-option value="">Select Company</mat-option>
                                      <mat-option *ngFor="let company of companyList" [value]="company.companyId" >
                                       {{company.companyName}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error matTooltip="The Company is required" matTooltipPosition="above">The Company is required</mat-error>
                                  </mat-form-field>
                            </div>
                            <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Last Name</mat-label>
                                    <input matInput placeholder="Last Name"  formControlName="lastName" autocomplete="chrome-off" maxlength="32"  (keydown)="onKeyDown($event)">
                                    <mat-error matTooltip="The last name is required" matTooltipPosition="above">The last name is required</mat-error>
                                  </mat-form-field>
                            </div>
                            <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>First Name</mat-label>
                                    <input matInput placeholder="First Name" formControlName="firstName" autocomplete="chrome-off" maxlength="32"   (keydown)="onKeyDown($event)">
                                    <mat-error matTooltip="The first name is required" matTooltipPosition="above">The first name is required</mat-error>
                                  </mat-form-field>
                            </div>
                            <div class="col-3">
                                <mat-form-field appearance="fill" style="width:100%;color:gray">
                                    <mat-label>Email Address</mat-label>
                                    <input matInput placeholder="Email Address" formControlName="primaryEmailAddress" autocomplete="chrome-off" maxlength="255"   (keydown)="onKeyDown($event)">
                                    <mat-error matTooltip="The email address is required" matTooltipPosition="above">The email address is required</mat-error>
                                  </mat-form-field>
                            </div>

                            <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%" >
                                    <mat-label>Card Number</mat-label>
                                    <input matInput placeholder="Card Number" formControlName="cardNumber" autocomplete="chrome-off" (input)="checkKeyCardIsValid()" (keypress)="keyPressCardNumber($event)"  maxlength="16" [errorStateMatcher]="errMatcher">
                                    <mat-error *ngIf="parkerEditForm.controls['cardNumber'].errors !== null" matTooltip="This card number has already been assigned to another parker on this lot." matTooltipPosition="above">This card number has already been assigned to another parker on this lot.</mat-error>
                                  </mat-form-field>
                            </div>
                        </div>
                
                
                        <div class="row row-gap-0">

                            <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Start Date</mat-label>
                                    <input matInput [matDatepicker]="startDate" formControlName="startDate" DateToCurrentYearStandalone autocomplete="chrome-off" >
                                    <mat-datepicker-toggle matIconSuffix [for]="startDate"></mat-datepicker-toggle>
                                    <mat-datepicker #startDate></mat-datepicker>
                                    <mat-error *ngIf="parkerEditForm.get('startDate')!.hasError('required')" matTooltip="The start date is required" matTooltipPosition="above">The start date is required</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>End Date</mat-label>
                                            <input matInput [matDatepicker]="endDate" [max]="maxEndDate" formControlName="endDate" DateToCurrentYearStandalone autocomplete="chrome-off">
                                            <mat-datepicker-toggle matIconSuffix [for]="endDate"></mat-datepicker-toggle >
                                            <mat-datepicker #endDate></mat-datepicker>
                                            @if (parkerEditForm.controls['endDate'].hasError('maxEndDate') || parkerEditForm.controls['endDate'].hasError('matDatepickerMax')) {
                                                <mat-error matTooltip="Not greater than {{maxEndDateDisplay}}" matTooltipPosition="above">Not greater than {{maxEndDateDisplay}}</mat-error>
                                            }
                                            @else if (parkerEditForm.controls['endDate'].errors !== null) {
                                                <mat-error matTooltip="Cannot be earlier than the start date." matTooltipPosition="above">Cannot be earlier than the start date.</mat-error>
                                            }
                                  </mat-form-field>
                            </div>

                            <div class="col-3">
                                <mat-form-field appearance="fill" style="width:100%;color:gray">
                                    <mat-label>Select Parker Pay Type</mat-label>
                                    <select matNativeControl formControlName="parkerPayType">
                                      <option value="">Select Pay Types</option>
                                      <option value="Parker">Parker</option>
                                      <option value="Company">Company</option>
                                    </select>
                                    <mat-error matTooltip="The Parker Pay Type is required" matTooltipPosition="above">The Parker Pay Type is required</mat-error>
                                  </mat-form-field>
                            </div>
                            <div class="col-3">
                                <mat-form-field appearance="fill" style="width:100%;color:gray">
                                    <mat-label>Select Invoice Delivery Method</mat-label>
                                    <mat-select formControlName="invoiceDeliveryMethod">
                                      <mat-option value="">Select Invoice Delivery Method</mat-option>
                                      <mat-option value="Email">Email</mat-option>
                                      <mat-option value="Print">Print</mat-option>
                                    </mat-select>
                                    <mat-error matTooltip="The Invoice Delivery Method is required" matTooltipPosition="above">The Invoice Delivery Method is required</mat-error>
                                   </mat-form-field>        
                            </div>

                            <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Phone</mat-label>
                                    <input matInput placeholder="Phone" formControlName="phone" autocomplete="chrome-off" maxlength="12" (keydown)="onKeyDown($event)">
                                  </mat-form-field>
                                  
                            </div>
                           
                        </div>

                        <div class="row row-gap-0">
                            <div class="col-5">
                                <mat-form-field appearance="fill" style="width:100%;color:gray">
                                    <mat-label>Rate</mat-label>
                                    <mat-select matNativeControl formControlName="rateNumber" (selectionChange)="onRateTypeChange();">
                                      <mat-option value="">Select Rate</mat-option>
                                      <mat-option *ngFor="let rate of marketRateList" [value]="rate.rateNumber.toString()" >
                                        ({{rate.rateType}})  {{rate.activeRate | currency }} - {{rate.description}}   -  {{GetTextForLotRateUsageMetrics(rate.rateNumber, rate.rateType)}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error matTooltip="The Rate is required" matTooltipPosition="above">The Rate is required</mat-error>
                                  </mat-form-field>
                            </div>

                            <div class="col-2">
                                     <mat-form-field appearance="outline" style="width:100%">
                                    <mat-label>Stall Type</mat-label>
                                    <input matInput placeholder="Stall Type" formControlName="stallType" readonly="true" >
                                </mat-form-field>
                            </div>
                            <div class="col-2">
                                <mat-form-field appearance="outline" style="width:100%">
                                    <mat-label>Description</mat-label>
                                    <input matInput placeholder="Description" formControlName="description" readonly="true">
                                </mat-form-field>
                            </div>

                            <div class="col-1">
                                <mat-form-field appearance="outline" style="width:100%">
                                    <mat-label>Tax Exempt?</mat-label>
                                    <input matInput placeholder="Tax Exempt" formControlName="isTaxExempt" readonly="true">
                                </mat-form-field>
                            </div>
                            
                            <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Stall Number</mat-label>
                                    <input matInput placeholder="Stall Number" formControlName="stallNumber" autocomplete="chrome-off" maxlength="12"   (keydown)="onKeyDown($event)">
                                  </mat-form-field>
                                  
                            </div>
                        </div>
                
                        <div class="row row-gap-0">
                            <div class="col-3">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Billing Address 1</mat-label>
                                    <input matInput placeholder="Billing Address 1" formControlName="billingAddress1" autocomplete="chrome-off" maxlength="255"   (keydown)="onKeyDown($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-3">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Billing Address 2</mat-label>
                                    <input matInput placeholder="Billing Address 2" formControlName="billingAddressLine" autocomplete="chrome-off" maxlength="255"   (keydown)="onKeyDown($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Billing City</mat-label>
                                    <input matInput placeholder="Billing City" formControlName="billingCity" autocomplete="chrome-off" maxlength="32"   (keydown)="onKeyDown($event)">
                                </mat-form-field>
                            </div>

                           

                            <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%;color:gray">
                                    <mat-label>Billing State</mat-label>
                                    <mat-select matNativeControl formControlName="billingState">
                                      <mat-option value="">Select State</mat-option>
                                      <mat-option *ngFor="let state of billingStates" [value]="state.stateAbbreviation" >
                                        {{state.stateFullName}}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                            </div>

                            <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Billing Zip Code</mat-label>
                                    <input matInput placeholder="Billing Zip Code" formControlName="billingZipCode" autocomplete="chrome-off" maxlength="12"   (keydown)="onKeyDown($event)" (blur)="onValidateVehicleLicense()">
                                </mat-form-field>
                            </div>
                        </div>
                        <!-- <div class="row row-gap-0">
                            <div class="col-3">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Vehicle Make</mat-label>
                                    <input matInput placeholder="Vehicle Make" formControlName="vehicleMake" autocomplete="chrome-off" maxlength="32"   (keydown)="onKeyDown($event)" (blur)="onValidateVehicleLicense()">
                                </mat-form-field>
                            </div>
                          
                            <div class="col-3">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Vehicle Model</mat-label>
                                    <input matInput placeholder="Vehicle Model" formControlName="vehicleModel" autocomplete="chrome-off" maxlength="32"   (keydown)="onKeyDown($event)" (blur)="onValidateVehicleLicense()">
                                </mat-form-field>
                            </div>

                            <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Vehicle Color</mat-label>
                                    <input matInput placeholder="Vehicle Color" formControlName="vehicleColor" autocomplete="chrome-off" maxlength="16"  (blur)="onValidateVehicleLicense()">
                                </mat-form-field>
                            </div>

                            <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%;color:gray">
                                <mat-label>Vehicle State</mat-label>
                                <mat-select matNativeControl formControlName="vehicleState" (blur)="onValidateVehicleLicense()">
                                  <mat-option value="">Vehicle State</mat-option>
                                  <mat-option *ngFor="let state of billingStates" [value]="state.stateAbbreviation" >
                                    {{state.stateFullName}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>

                              <div class="col-2">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Vehicle License Plate</mat-label>
                                    <input matInput placeholder="Vehicle License Plate" formControlName="vehicleLicense" (keypress)="keyPressAlphanumeric($event)" 
                                        autocomplete="chrome-off" maxlength="16" (blur)="onValidateVehicleLicense()">
                                     <mat-error *ngIf="parkerEditForm.controls['vehicleLicense'].errors !== null" matTooltip="The Vehicle License Plate is required if any other vehicle data is entered." matTooltipPosition="above">The Vehicle License Plate is required if any other vehicle data is entered.</mat-error>
                                </mat-form-field>
                            </div>
                        </div> -->

                        <div class="row row-gap-0">
                            <div class="col-12">
                                <mat-form-field appearance="fill" style="width:100%">
                                    <mat-label>Comments</mat-label>
                                    <textarea matInput placeholder="Comments" formControlName="comments" maxlength="2048" (keydown)="onKeyDown($event)"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                        <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="isProcessingSave || !parkerEditForm.valid || vehicleLicenseInvalid ">Submit</button>
                        <button type="button" class="btn btn-light mt-3" style="margin-left:5px;" (click)="onCancelParkerProfileEditData()">Cancel</button>
                        </form>
                        <div style="margin-top:20px;"></div>
                      
                    </mat-card-content>
                    <mat-card-actions style="margin-top:20px;">
                        <hr />
                    
                      </mat-card-actions>
                  
                </mat-card>
        </div>
    } 
            
            
            



